module.exports = __webpack_public_path__ + "img/logo_wowotown.87b7b04f.png";